import { EvtHeader } from "components/header";
import TestimonialForm from "@/modules/crm/clients/testimonials/crud/form";
import React from "react";
import { useParams } from "react-router-dom";

const CreateTestimonial = () => {
  const { clientId } = useParams();
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Testimonial" />
      <div className="p-6 max-w-2xl">
        <TestimonialForm clientId={clientId} />
      </div>
    </div>
  );
};

export default CreateTestimonial;
